import { Injectable } from "@angular/core";
import { UseCase } from "../../base";
import { Observable } from "rxjs";
import { UserRulesTemplateRepository } from "../../repositories/user-rules-template.repository";
import { UserRulesTemplate } from "../../domain/models/user-rules-template";
@Injectable({ providedIn: 'root' })
export class GetUserRulesTemplatesIncludingDefaultUsecase implements UseCase<null, UserRulesTemplate[]> {
  constructor(private readonly userRulesTemplateRepository: UserRulesTemplateRepository) {
  }

  execute(): Observable<UserRulesTemplate[]> {
    return this.userRulesTemplateRepository.getUserRulesTemplatesByUserIdIncludingDefault();
  }
}
